import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_BANK_CARD_OR_TRAVEL_DOCUMENTS_STATE,
  RESET_CASH_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    whatItemsAreYouClaimingFor: [],
    infoBankCardsOrTravelDocumentsItems: [],
    infoCashItems: [],
  },
  errors: [],
});

const initialBankCardsOrTravelDocuments = {
  form: {
    infoBankCardsOrTravelDocumentsItems: [],
  },
};

const initialCash = {
  form: {
    infoCashItems: [],
  },
};

function cashBankCardsTravelDocumentsAndPassportsStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_BANK_CARD_OR_TRAVEL_DOCUMENTS_STATE:
      return state
        .setIn(['form', 'infoBankCardsOrTravelDocumentsItems'], [])
        .mergeDeep(initialBankCardsOrTravelDocuments);
    case RESET_CASH_STATE:
      return state
        .setIn(['form', 'infoCashItems'], [])
        .mergeDeep(initialCash);
    default:
      return state;
  }
}

export default cashBankCardsTravelDocumentsAndPassportsStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.CashBankCardsTravelDocumentsAndPassports/reducer.js